import React, { useState } from 'react';
import './PhoneButton.css';

function PhoneButton() {
  const [hoveredItem, setHoveredItem] = useState(null);
  
  return (
    <div className="contact-buttons-container">
      {/* 联系电话按钮 */}
      <div 
        className="contact-button-wrapper"
        onMouseEnter={() => setHoveredItem('phone')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <button className="contact-button phone-button">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
          </svg>
        </button>
        
        {hoveredItem === 'phone' && (
          <div className="contact-card glass-effect">
            <h3 className="contact-card-title">客服电话</h3>
            <div className="contact-card-content">
              <p className="contact-card-info">工作时间: 19:00-6:00</p>
              <p className="contact-card-info">号码: 17388921024</p>
            </div>
          </div>
        )}
      </div>

      {/* 联系微信按钮 */}
      <div 
        className="contact-button-wrapper"
        onMouseEnter={() => setHoveredItem('wechat')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <button className="contact-button wechat-button">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M9.5,4C5.36,4 2,6.69 2,10C2,11.89 3.08,13.56 4.78,14.66L4,17L6.5,15.5C7.39,15.81 8.37,16 9.41,16C9.15,15.37 9,14.7 9,14C9,10.69 12.13,8 16,8C16.19,8 16.38,8 16.56,8.03C15.54,5.69 12.78,4 9.5,4M6.5,6.5A1,1 0 0,1 7.5,7.5A1,1 0 0,1 6.5,8.5A1,1 0 0,1 5.5,7.5A1,1 0 0,1 6.5,6.5M11.5,6.5A1,1 0 0,1 12.5,7.5A1,1 0 0,1 11.5,8.5A1,1 0 0,1 10.5,7.5A1,1 0 0,1 11.5,6.5M16,9C13.24,9 11,11.24 11,14C11,16.76 13.24,19 16,19C16.67,19 17.31,18.85 17.88,18.57L20,20L19.23,17.89C20.32,16.97 21,15.56 21,14C21,11.24 18.76,9 16,9M14,11.5A1,1 0 0,1 15,12.5A1,1 0 0,1 14,13.5A1,1 0 0,1 13,12.5A1,1 0 0,1 14,11.5M18,11.5A1,1 0 0,1 19,12.5A1,1 0 0,1 18,13.5A1,1 0 0,1 17,12.5A1,1 0 0,1 18,11.5Z" />
          </svg>
        </button>
        
        {hoveredItem === 'wechat' && (
          <div className="contact-card glass-effect wechat-card">
            <h3 className="contact-card-title">扫码添加微信</h3>
            <div className="contact-card-content">
              <div className="qrcode-container">
                {/* 这里放置微信二维码图片 */}
                <img src="https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/system/2024/02-03/2027015bbad9698909.jpg?time=1707023138?version=25.1.5" alt="微信二维码" className="qrcode-image" />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 联系邮件按钮 */}
      <div 
        className="contact-button-wrapper"
        onMouseEnter={() => setHoveredItem('email')}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <button className="contact-button email-button">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
          </svg>
        </button>
        
        {hoveredItem === 'email' && (
          <div className="contact-card glass-effect email-card">
            <h3 className="contact-card-title">联系邮箱</h3>
            <div className="contact-card-content">
              <p 
                className="contact-card-info" 
                onClick={() => {
                  navigator.clipboard.writeText('plane@qiqiker.com');
                  // 创建一个临时提示元素
                  const toast = document.createElement('div');
                  toast.style.cssText = `
                    position: fixed;
                    bottom: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    background: rgba(0, 0, 0, 0.8);
                    color: white;
                    padding: 10px 20px;
                    border-radius: 4px;
                    z-index: 10000;
                  `;
                  toast.textContent = '邮箱已复制到剪贴板!';
                  document.body.appendChild(toast);
                  
                  // 2秒后移除提示
                  setTimeout(() => {
                    document.body.removeChild(toast);
                  }, 2000);
                }}
                style={{ cursor: 'pointer' }}
              >
                客服邮箱: plane@qiqiker.com
              </p>
              <p className="contact-card-info">工作时间: 全天候服务</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PhoneButton; 